import { type useFilterParams } from './FilterParamsProvider'

export type FilterParamsState = ReturnType<typeof useFilterParams>

export const InsightsWeekStartDayLocalStorageKey = 'insightsPortal.weekStartDay' as const
export const InsightsComparisonPeriodPreferenceLocalStorageKey =
  'insightsPortal.comparisonPeriod.preference' as const
